var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 82,
    cy: 82,
    r: 82,
    fill: "#61E5E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_15562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 152,
    height: 152
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.9999,
    cy: 81.9999,
    r: 75.2909,
    fill: "#73E5FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_15562)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 81.9996,
    cy: 82.0001,
    r: 76.7818,
    fill: "#39E4B9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_264_15562)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.291,
    y: 49.1997,
    width: 95.4182,
    height: 53.6727,
    rx: 9.07216,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_264_15562)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.1816,
    y: 108.836,
    width: 59.6364,
    height: 5.96364,
    rx: 2.98182,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.2549,
    y: 56.1636,
    width: 81.4909,
    height: 39.7455,
    rx: 7,
    stroke: "#E6E6E6",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_264_15562",
    x: 24.0848,
    y: 40.1275,
    width: 115.83,
    height: 74.0852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13402
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10309
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_264_15562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_264_15562",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_264_15562",
    x: 41.9755,
    y: 99.7638,
    width: 80.0491,
    height: 26.3762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13402
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10309
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_264_15562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_264_15562",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIllustration);
export default __webpack_public_path__ + "static/media/desktop-illustration.ef14bbd6.svg";
export { ForwardRef as ReactComponent };